import CustomModal from '../../../../baseComponents/gui/customModal/CustomModal';
import classNames from 'classnames';
import combineModifiers from '../../../../../utils/modifiers/combineModifiers';
import { useRequests } from '../../../../../redux/reducer/requests';
import { components as componentsData } from '../../config/components';
import { wrappers } from '../../config/wrappers';
import { DEFAULT as DEFAULT_WRAPPER } from '../../constants/wrappers';
import { DEFAULT as DEFAULT_COMPONENT } from '../../constants/components';

export default function UniversalModal({ components = [], modalProps = {} }) {
  const {
    authData: { isWeb },
  } = useRequests();

  return (
    <CustomModal {...modalProps.wrapper}>
      <div
        className={classNames(
          'universal-modal',
          modalProps.className,
          ...combineModifiers('universal-modal', modalProps.modifier),
          { app: !isWeb },
        )}
      >
        {components.map(({ wrapper = {}, list, key }, index) => {
          const Wrapper = wrappers[wrapper.type] ?? wrappers[DEFAULT_WRAPPER];
          return (
            <Wrapper key={key ?? index} {...(wrapper.props ?? {})}>
              {list.map(({ type, props = {}, key }, subIndex) => {
                const Component = componentsData[type] ?? componentsData[DEFAULT_COMPONENT];
                return <Component key={key ?? subIndex} {...props} />;
              })}
            </Wrapper>
          );
        })}
      </div>
    </CustomModal>
  );
}
